<script>
export default {
  name: "ElTagColorContracts",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const rowValue = context.props.row;
    let reason = rowValue.TipoContrato;

    if (reason == "Mensual") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--info el-tag--plain"
        },
        val
      );
    } else if (reason == "Anual") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--warning el-tag--plain"
        },
        val
      );
    } else {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--danger el-tag--plain"
        },
        val
      );
    }
  }
};
</script>
